import http from '@/utils/http.js'

export function login(query) {
    return http.post("/app-api/login", query)
}
export function smsLogin(query) {
    return http.post("/app-api/smsLogin", query)
}
export function captcha(query) {
    return http.get("/app-api/captchaImage")
}
export function userInfo(query) {
    return http.get("/app-api/getInfo")
}
export function captchaSms(phone) {
    return http.get("/app-api/captchaSms?phonenumber=" + phone)
}
export function currentStudent() {
    return http.get("/app-api/chicago/studentInfo/currentStudent")
}
export function updateScore(query) {
    return http.post("/app-api/chicago/scoreRank/matchRankByScore",query)
}
export function updateStudent(query) {
    return http.put("/app-api/chicago/studentInfo/editCurrentStudent", query)
}
export function listChoice(query) {
    return http.get("/app-api/chicago/collegeChoice/listChoice", query)
}
export function getProvinceInfo(query) {
    return http.get("/app-api/app/chicago/sysArea/list", query)
}
//查询可切换省份
export function getSupportProvince(query) {
    return http.get("/app-api/system/dict/data/type/support_province", query)
}
// 继续填报
export function activeChoice(query) {
    return http.put("/app-api/chicago/collegeChoice/activeChoice", query)
}
// 删除志愿
export function removeCollegeChoice(id) {
    return http.delete("/app-api/chicago/collegeChoice/"+id)
}
// 个人中心导出
export function exportUser(query) {
    return http.post("/app-api/chicago/choice/export", query)
}
// 志愿详情
export function collegeChoiceDetail(query) {
    return http.get("/app-api/chicago/collegeChoiceDetail/list", query)
}
// 激活VIP
export function boundMember(query) {
    return http.post("/app-api/chicago/studentInfo/boundMember", query)
}
